<template>
  <v-card flat>
    <v-navigation-drawer class="text-left store-navigation" color="white" v-model="drawer" absolute temporary>
      <template v-slot:prepend>
        <v-list-item two-line class="header">
          <v-list-item-content>
            <div v-if="isAuthenticated">
              <v-list-item-title>Hola</v-list-item-title>
              <v-list-item-subtitle v-if="_user">{{ _user.first_name }}</v-list-item-subtitle>
            </div>
            <div v-else>
              <v-list-item-title>Hola</v-list-item-title>
              <v-list-item-subtitle>
                <div class="identify" @click="goToRouteByName('Login')">Identificarse</div>
              </v-list-item-subtitle>
            </div>
          </v-list-item-content>
          <v-spacer></v-spacer>
          <v-list-item-avatar v-if="isAuthenticated">
            <v-btn icon @click="signOff">
              <v-icon color="#606060">power_settings_new</v-icon>
            </v-btn>
          </v-list-item-avatar>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <div v-for="(section, index) in menu" :key="section.key">
        <v-divider v-if="index > 0"></v-divider>
        <v-list dense nav>
          <v-subheader class="text-uppercase" v-if="section.title">{{ section.title }}</v-subheader>
          <div v-for="item in section.items" :key="item.title">
            <v-list-item link v-if="showMenuItem(item)" @click="goToRouteByName(item.name)">
              <v-list-item-icon>
                <v-icon color="#606060">{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>

              <v-list-item-action class="mr-n3" v-if="item.title === 'Carrito de compras' && totalShoppingCart > 0">
                <v-icon x-small color="blue darken-2" class="no-see-icon">
                  mdi-checkbox-blank-circle
                </v-icon>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-list>
      </div>
    </v-navigation-drawer>
    <div class="main-container">
      <v-content class="page">
        <toolbar>
          <template v-slot:drawer>
            <v-app-bar-nav-icon color="#606060" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          </template>
        </toolbar>
        <notification-popup ref="popup"></notification-popup>
        <router-view @notificationPopup="showNotification" />
      </v-content>
      <v-card flat tile v-if="$vuetify.breakpoint.mdAndUp || $route.meta.showFooterInMobile">
        <v-footer class="transparent-footer" padless>
          <content-footer></content-footer>
        </v-footer>
      </v-card>
    </div>
  </v-card>
</template>
<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import Toolbar from '@/layouts/Store/Toolbar'
import NotificationPopup from '@/components/Shared/NotificationPopup'
import ContentFooter from '@/layouts/Store/ContentFooter'
import { MENU } from '@/config/menu'
import { tokenToJSON } from '@/shared/token'

export default {
  mixins: [navigationMixin],
  components: {
    Toolbar,
    NotificationPopup,
    ContentFooter
  },
  data () {
    return {
      drawer: false,
      menu: MENU
    }
  },
  computed: {
    ...mapState('shared', ['loading']),
    ...mapState('auth', ['isAuthenticated']),
    ...mapState('user', ['_user']),
    ...mapState('notification', ['notificationAdded']),
    ...mapGetters('cart', ['totalShoppingCart'])
  },
  methods: {
    ...mapMutations('cart', ['cleanShoppingCart']),
    ...mapMutations('notification', ['cleanNotificationAdded']),
    ...mapActions('auth', ['logout']),
    ...mapActions('websocket', ['closeConnection']),
    ...mapActions('user', ['getUser']),
    showNotification (notification) {
      this.$refs.popup.show(notification)
    },
    showMenuItem (item) {
      return (this.isAuthenticated && item.show.isAuthenticated) || (!this.isAuthenticated && item.show.isNotAuthenticated)
    },
    async signOff () {
      this.cleanShoppingCart()
      await this.closeConnection()
      await this.logout()
      this.goToRouteByName('Login')
    }
  },
  watch: {
    notificationAdded (notification) {
      if (!notification) {
        return
      }

      this.$refs.popup.show(notification)
      this.cleanNotificationAdded()
    }
  },
  mounted () {
    const jsonToken = tokenToJSON()
    if (jsonToken && jsonToken.user_id) {
      this.getUser(jsonToken.user_id)
    }
  }
}
</script>
<style scoped>
.main-container {
  min-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.page {
  flex: 1;
  /*background-color: #EBEBEB;*/
  /*background-color: #F4F5F7;*/
  background-color: #F9F9F9;
}

.transparent-footer {
  background: transparent;
}

.container {
  padding: 0;
}

.identify {
  cursor: pointer;
}

.header {
  background-color: #ECECEC;
}

.store-navigation {
  position: fixed;
  top:0;
  left:0;
  overflow: hidden;
}

.no-see-icon{
  font-size: 9px !important;
}
</style>
